import { Image } from '@chakra-ui/image';
import logo from '../assets/2024_SmartThings_Color_B_RGB.svg';

const Header = () => (
	<Image h={12} src={logo} alt="SmartThings®" alignSelf="flex-start" />
);

export default Header;
